import ScenarioSelector from "./ScenarioSelector";

function App() {
  return <ScenarioSelector />;
}

export default App;
